(function() {
'use strict';
  
  angular
    .module('app.shell')
    .controller('ShellMissingStateController', ShellMissingStateController);
      
  ShellMissingStateController.$inject = ['$log', '$state', '$stateParams', 'shell'];
    
  function ShellMissingStateController($log, $state, $stateParams, shell) {
    $log = $log.getInstance('ShellMissingStateController');
    
    /* jshint validthis: true */
    var vm = this;

    vm.fromParams = $stateParams.fromParams;
    vm.fromState = $stateParams.fromState.name;
    vm.stateParams = $stateParams;
    vm.toParams = $stateParams.toParams;
    vm.toState = $stateParams.toState;
    
    activate();

    function activate() {
      shell.setTitle('Mars');
      shell.setTheme('error');
      $log.error(vm.fromState + ' -> ' + vm.toState, $stateParams);
    }
    
  }
  
})();